import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ConfigService } from './config.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "./config.service";
export class EvidenciaService {
    constructor(http, configService) {
        this.http = http;
        this.configService = configService;
        this.jsonContent = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': sessionStorage.getItem('batoken'),
                'User': sessionStorage.getItem('userid')
            })
        };
    }
    list(capacitacionId) {
        return this.http.get(`${this.configService.API_URL}/evidencia/list/${capacitacionId}`, Object.assign({}, this.jsonContent)).toPromise();
    }
    listTemp(tempId) {
        return this.http.get(`${this.configService.API_URL}/evidencia/listTemp/${tempId}`, Object.assign({}, this.jsonContent)).toPromise();
    }
    delete(fileId) {
        return this.http.post(`${this.configService.API_URL}/evidencia/delete?id=${fileId}`, Object.assign({}, this.jsonContent)).toPromise();
    }
    download(fileId) {
        return this.http.get(`${this.configService.API_URL}/evidencia/download/${fileId}`, Object.assign({}, this.jsonContent)).toPromise();
    }
    downloadFile(fileId, name) {
        this.http.get(`${this.configService.API_URL}/evidencia/download/${fileId}`, Object.assign({}, this.jsonContent, { responseType: 'blob' })).subscribe((response) => {
            let dataType = response.type;
            let binaryData = [];
            binaryData.push(response);
            let downloadLink = document.createElement('a');
            downloadLink.download = name;
            downloadLink.href = window.URL.createObjectURL(new Blob(binaryData, { type: dataType }));
            downloadLink.style.display = 'none';
            document.body.appendChild(downloadLink);
            downloadLink.click();
        }, error => console.log(error), () => { console.log("completed"); });
    }
    upload(capacitacionId, file) {
        return this.http.post(`${this.configService.API_URL}/evidencia/upload?capacitacionId=${capacitacionId}`, file).toPromise();
    }
    uploadTemp(uuid, file) {
        return this.http.post(`${this.configService.API_URL}/evidencia/uploadTemp${uuid == null ? '' : '?tempFolder=' + uuid}`, file).toPromise();
    }
    saveTemp(uuid, id) {
        return this.http.post(`${this.configService.API_URL}/evidencia/rename?tempFolder=${uuid}&capacitacionId=${id}`, Object.assign({}, this.jsonContent)).toPromise();
    }
}
EvidenciaService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function EvidenciaService_Factory() { return new EvidenciaService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.ConfigService)); }, token: EvidenciaService, providedIn: "root" });
